import { clsx } from 'clsx';
import { ReactElement, ReactNode, Ref, SelectHTMLAttributes } from 'react';
import { Icon } from '../../Icon';
import { InputStateVariant } from '../InputProps.types';
import styles from './select.module.scss';

export interface SelectProps
  extends SelectHTMLAttributes<HTMLSelectElement>,
    HTMLDataAttributes {
  children?: ReactNode;
  className?: string;
  state?: InputStateVariant;
  _ref?: Ref<HTMLSelectElement>;
}

/**
 * Select component
 *
 * @warning This component is a style wrapper only, subject to change
 */
export const Select = ({
  children,
  className,
  state = 'neutral',
  _ref,
  ...props
}: SelectProps): ReactElement => {
  return (
    <span className={clsx(styles.select, className)} data-state={state}>
      <select ref={_ref} {...props} role="listbox">
        {children}
      </select>

      <span className={styles.chevron} data-state={state}>
        <Icon name={'chevron-down'} size={'m'} />
      </span>
    </span>
  );
};
